const blogFields = `
  _id,
  name,
  title,
  date,
  excerpt,
  coverImage,
  category,
  mdx,
  live,
  "slug": slug.current,
  "author": author->{name, picture},
  seo,
  featured
`;

const tutorialFields = `
_id,
name,
title,
excerpt,
coverImage,
category,
live,
"slug": slug.current,
"author": author->{name, picture},
time,
markdown,
body[] {
  ...,
  markDefs[]{
    ...,
    _type == "internalLink" => {
      "slug": @.reference->slug
    }
  },
  body[] {
    ...,
    markDefs[]{
      ...,
      _type == "internalLink" => {
        "slug": @.reference->slug
      }
    }
  },
},
seo
`;

const docFields = `
  _id,
  seo,
  title,
  subtitle,
  body[] {
    ...,
    markDefs[]{
      ...,
      _type == "internalLink" => {
        "slug": @.reference->slug
      }
    },
    body[] {
      ...,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.reference->slug
        }
      }
    },
  },
  "slug": slug.current
`;

const authorFields = `
  _id,
  name,
  picture,
  role,
  socials,
  teammate
`;

const investorFields = `
  _id,
  name,
  picture,
  role,
  url
`;

const pageFields = `
  _id,
  seo,
  pageText,
  pageCode,
  pageImage,
  pageJSON,
  body[]{
    ...,
    richText[]{
      ...,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.reference->slug
        }
      }
    }
  },
  "slug": slug.current,
`;

export const blogIndexQueryProduction = `
*[_type == "blog" && live == true && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {
  ${blogFields}
}`;

export const blogIndexQueryPreview = `
*[_type == "blog" && !(_id in path('drafts.**'))]  | order(date desc, _updatedAt desc) {
  ${blogFields}
}`;

export const guidesIndexQueryProduction = `
*[(_type == 'tutorial' || _type == "blog") && live == true && (category == "Guide" || category == "Tutorial") && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {
  ${blogFields}
}`;

export const guidesIndexQueryPreview = `
*[(_type == 'tutorial' || _type == "blog") && (category == "Guide" || category == "Tutorial") && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {
  ${blogFields}
}`;

export const authorQuery = `
*[_type == "author"] | order(order asc) {
  ${authorFields}
}`;

export const investorQuery = `
*[_type == "investor"] | order(order asc) {
  ${investorFields}
}`;

export const docQuery = `
*[_type == "doc"] {
  ${`  _id,
  title,
  "slug": slug.current`}
}`;

export const blogQuery = `
{
  "blog": *[_type == "blog" && slug.current == $slug] | order(_updatedAt desc)[0]{
    "body": body[]{
      ...,
      authors[]->,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.reference->slug
        }
      },
      body[] {
        ...,
        markDefs[]{
          ...,
          _type == "internalLink" => {
            "slug": @.reference->slug
          }
        }
      }
},
    ${blogFields}
  },
  "moreBlogs": *[_type == "blog" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {
    "body": body[]{
      ...,
      authors[]->,
},
    ${blogFields}
  }
}`;

export const tutorialQuery = `
{
  "tutorial": *[_type == "tutorial" && slug.current == $slug] | order(_updatedAt desc)[0]{
    "body": body[]{
      ...,
      authors[]->,
},
    ${tutorialFields}
  },
  "moreTutorials": *[_type == "tutorial" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {
    "body": body[]{
      ...,
      authors[]->,
},
    ${tutorialFields}
  }
}`;

export const pageQuery = `
{
  "page": *[_type == "page" && slug.current == $slug] | order(_updatedAt desc)[0] {
    content,
    ${pageFields}
  },
}`;

export const siteSettingsQuery = `
*[_type == "siteSettings"] | order(order asc)`;

export const blogSlugsQueryProduction = `
*[_type == "blog" && live == true && defined(slug.current)][].slug.current
`;

export const blogSlugsQueryPreview = `
*[_type == "blog" && defined(slug.current)][].slug.current
`;

export const blogBySlugQuery = `
*[_type == "blog" && slug.current == $slug][0] {
  ${blogFields}
}
`;

export const tutorialSlugsQueryProduction = `
*[_type == "tutorial" && live == true && defined(slug.current)][].slug.current
`;

export const tutorialSlugsQueryPreview = `
*[_type == "tutorial" && defined(slug.current)][].slug.current
`;

export const tutorialBySlugQuery = `
*[_type == "tutorial" && slug.current == $slug][0] {
  ${tutorialFields}
}
`;

export const marketingLPSlugsQuery = `
*[_type == "marketing-lp" && defined(slug.current)][].slug.current
`;

export const marketingLPBySlugQuery = `
{
  "page": *[_type == "marketing-lp" && slug.current == $slug][0] {
    ${pageFields}
  }
}
`;

export const docSlugsQuery = `
*[_type == "doc" && defined(slug.current)][].slug.current
`;

export const docBySlugQuery = `
*[_type == "doc" && slug.current == $slug] | order(_updatedAt desc)[0] {
  ${docFields}
}
`;

export const navigationQuery = `
*[navId.current match "docs-*"] | order(order asc) {
  name,
 "navId": navId.current,
 "categories": linkCategories[]{
   "categoryId": categoryId.current,
   categoryName,
   links[] {
     _key,
     title,
     "slug": internalLink->slug.current,
     "url": externalLink.href,
     "childLinks": links[]{
       _key, 
       title, 
       "slug": internalLink->slug.current, 
       "url": externalLink.href
     }
   }
 }
}
`;
